import React, { useEffect, useRef } from 'react';
import SalesOrderRepository from '../../../../../repositories/SalesOrderRepository';
import { AxiosError, AxiosResponse } from 'axios';
import { showToast } from '../../../../../vodea/utilities/helpers/global';
import { useReactToPrint } from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import PrintNewSalesOrderReceipts from '../../../../../prints/PrintNewSalesOrderReceipts';
import { useState } from '@hookstate/core/dist';

const ActionPrintSalesOrder = ({ salesOrderId }) => {
  const [data, setData] = React.useState<any>(null);
  const printReceiptsRef = useRef<any>();
  const openPrint = useState(
    useReactToPrint({
      content: () => printReceiptsRef.current,
      onAfterPrint: () => {}
    })
  );

  const handlePrintReceipts = useReactToPrint({
    content: () => printReceiptsRef.current,
    onAfterPrint: () => {}
  });

  const handlePrint = async () => {
    await SalesOrderRepository.print(salesOrderId)
      .then(() => {
        openPrint.set(handlePrintReceipts);
      })
      .catch(() => {});
  };

  const getData = async () => {
    await SalesOrderRepository.show(salesOrderId, {
      with: [
        'channel',
        'customer',
        'salesOrderItems.type',
        'salesOrderItems.product',
        'salesOrderItems.unit',
        'salesOrderItems.storage',
        'creator',
        'sales'
      ]
    })
      .then((response: AxiosResponse) => {
        const data = response.data.data;
        const products = [];
        data?.sales_order_items?.forEach((item: any) => {
          products.push({
            product_id: item.product,
            unit_id: item.unit,
            price: Number(item.price),
            quantity: Number(item.quantity),
          });
        });

        const formatterData = {
          number: data.number,
          date: data.date,
          creatorName: data?.creator?.name,
          dueDate: data.due_date,
          customer_id: data.customer,
          note: data.note,
          discount: Number(data?.discount || 0),
          products,
          summary: {
            subtotal: Number(data?.subtotal || 0),
            discount: Number(data?.product_discount || 0),
            total: Number(data?.grand_total || 0),
            payment: Number(data?.payment_amount || 0),
            balance: Number(data?.outstanding || 0)
          }
        }

        setData(formatterData);
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  useEffect(() => {
    if (salesOrderId) {
      (async () => {
        await getData().then();
      })();
    }
  }, [salesOrderId]); // eslint-disable-line

  return (
    <div>
      <button type={'button'} className={'btn btn-success action-item'} onClick={handlePrint}>
        <FontAwesomeIcon className={'icon icon-prefix'} icon={faReceipt} />
        Print Receipts
      </button>

      <div className='visually-hidden'>
        <PrintNewSalesOrderReceipts
          id={salesOrderId}
          data={data}
          componentRef={printReceiptsRef}
        />
      </div>
    </div>
  )
}

export default ActionPrintSalesOrder;